import {
  ChartPieIcon,
  ClockIcon,
  CpuChipIcon,
  ExclamationCircleIcon,
  TruckIcon,
  UsersIcon,
} from '@heroicons/react/24/outline';

// ── Navegación sidebar ─────────────────────────────────────────────────────
export const NAV = [
  {
    seccion: 'Principal',
    items: [
      { path: '/',           label: 'Dashboard',       Icon: ChartPieIcon },
      { path: '/incidentes', label: 'Nuevo Incidente', Icon: ExclamationCircleIcon },
      { path: '/despacho',   label: 'Despacho',        Icon: TruckIcon },
    ],
  },
  {
    seccion: 'Análisis',
    items: [
      { path: '/prediccion', label: 'Predicción IA', Icon: CpuChipIcon },
      { path: '/historial',  label: 'Historial',     Icon: ClockIcon },
    ],
  },
  {
    seccion: 'Administrar',
    items: [
      { path: '/usuarios', label: 'Usuarios', Icon: UsersIcon },
    ],
  },
];

// ── Niveles de urgencia ────────────────────────────────────────────────────
export const URGENCIAS = [
  { nivel: 1, label: 'Baja',     prioridad: 'baja',    border: '#27ae60', bg: '#eafaf1', color: '#1a7a3c' },
  { nivel: 2, label: 'Moderada', prioridad: 'baja',    border: '#f0b429', bg: '#fefbd8', color: '#7d6608' },
  { nivel: 3, label: 'Media',    prioridad: 'media',   border: '#e67e22', bg: '#fef3e8', color: '#b7770d' },
  { nivel: 4, label: 'Alta',     prioridad: 'alta',    border: '#e74c3c', bg: '#fde8e8', color: '#c0392b' },
  { nivel: 5, label: 'Crítica',  prioridad: 'critica', border: '#8e1010', bg: '#fde8e8', color: '#8e1010' },
];

// ── Configuración geográfica ───────────────────────────────────────────────
export const COD_DEPARTAMENTO_JALAPA = 1302;
export const LAT_DEFAULT = 14.638;
export const LON_DEFAULT = -89.981;